import PropTypes from 'prop-types';
import MarTechAssessment from '../../../static-content/martech-assessment.json';
import { renderMarTechAssessmentResultsPage } from '../../../templates/digitial-martech-maturity-health-check/martech-assessment-results';
import { EN_UK } from '../../../utils/geo-space-id-helpers';

const propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object
  })
};

/**
 * Page that renders results from a completed MarTech Assessment form.
 *
 * @component MarTechAssessmentResultsPage
 * @returns {JSX} MarTech Assessment results page
 * @param {*} props
 * @prop {object} location
 */
const MarTechAssessmentResultsPage = props => {
  const SEO_SLUG = `/${EN_UK}/digital-martech-maturity-health-check/results`;

  return renderMarTechAssessmentResultsPage(MarTechAssessment, props, SEO_SLUG);
};

MarTechAssessmentResultsPage.propTypes = propTypes;

export default MarTechAssessmentResultsPage;
